<script setup lang="ts">
import LazyImage from '~/components/design-system/lazy-image.vue';
import type { TStandardImageKeys } from 'assets/data/branding-library';

defineProps<{ iconName: TStandardImageKeys; title: string; alt: string }>();
const { getImage, getPlaceholder } = useBranding();
const colorMode = useColorMode();
</script>

<template>
  <div
    class="flex py-3"
    :class="{
      'justify-between': $slots?.['header-actions-right'],
      'justify-start': !$slots?.['header-actions-right'],
    }"
  >
    <div class="flex items-center">
      <LazyImage
        class="text-center mt-0.5 mr-2 ml-0 invert dark:invert-0 w-6 h-6"
        :src="getImage(iconName)"
        :placeholder="getPlaceholder('iconPlaceholder')"
        :style="`filter: invert(${colorMode?.preference === 'dark' ? 0 : 1})`"
        :alt="alt"
      />
      <p class="font-bold text-2xl dark:text-light-50 capitalize">
        {{ $t(title) }}
      </p>
    </div>
    <slot name="header-actions-right" />
  </div>
</template>
